import React from 'react';

import QuotaCompra  from 'components/Tvendo/Sale/QuotaBPartner/Unilever/QuotaCompra/List.js';

export default function () {
  return <QuotaCompra  />;
}